import Vue from 'vue'
// Custom vue properties (https://vuejsdevelopers.com/2017/04/22/vue-js-libraries-plugins/?jsdojo_id=solip)
import lodash from 'lodash'
import moment from 'moment-timezone'
Object.defineProperty(Vue.prototype, '$lodash', { value: lodash })
Object.defineProperty(Vue.prototype, '$moment', { value: moment })
